export default __webpack_public_path__ + "static/media/keyboardAndMice.b26fa1cf.svg";